import { createMuiTheme } from "@material-ui/core";
import { orange } from "@material-ui/core/colors";

export const muiTheme = createMuiTheme({
  palette: {
    primary: orange,
  },
});
